import { Component } from 'react'
import { observer } from 'mobx-react'

import * as h from 'h'
import { filterRequestsByNamespace } from 'utils'

import { PopoutTransitionContainer } from 'components/Popout/PopoutTransitionContainer'
import SearchBar from 'components/SearchBar'
import Results from 'components/Results'
import ResultListItem from 'components/ResultListItem'
import ExpertiseResultItem from './ExpertiseResultItem'
import { informationalMessage } from 'config'

@observer(['UiStore', 'SearchStore', 'ExpertiseStore'])
export default class Search extends Component {
  componentWillMount () {
    const { UiStore, location } = this.props
    if (location.query.search) {
      UiStore.sitewideSearchFilters.search = location.query.search
    }
  }

  componentDidMount () {
    this.props.SearchStore.startFetcher()
  }

  componentWillUnmount () {
    this.props.SearchStore.stopFetcher()
  }

  get results () {
    return this.props.SearchStore.generics
  }

  get isRequestingGenerics () {
    return filterRequestsByNamespace(this.props.UiStore.requests, 'search').length > 0
  }

  get isRequestingKeywords () {
    return filterRequestsByNamespace(this.props.UiStore.requests, 'keywordsearch').length > 0
  }

  get isRequestingFaculty () {
    return filterRequestsByNamespace(this.props.UiStore.requests, 'facultysearch').length > 0
  }

  get isRequesting () {
    return this.isRequestingGenerics || this.isRequestingFaculty || this.isRequestingKeywords
  }

  render () {
    const { UiStore, SearchStore, ExpertiseStore } = this.props
    const { facultySearchResults: facultyHints } = SearchStore
    const { keywordHints } = ExpertiseStore
    const { sitewideSearchFilters } = UiStore

    const expertiseResultItemHasMeaningfulInformation = facultyHints.length > 0 || keywordHints.length > 0
    const showExpertiseResultItem = UiStore.pagination.current === 1 && expertiseResultItemHasMeaningfulInformation

    const elements = showExpertiseResultItem
      ? [ h.h(ExpertiseResultItem, { facultyHints, keywordHints }), ...this.results ]
      : this.results

    return h.div(null,
      h.h(SearchBar, {
        value: sitewideSearchFilters.search,
        onChange: value => { sitewideSearchFilters.search = value }
      }),
      h.h(PopoutTransitionContainer, null, this.props.children),
      h.h(Results, {
        resultComponent: ResultListItem,
        elements,
        isRequesting: this.isRequesting,
        onPageClick: () => null,
        hideResultsUntilFinishedRequesting: true
      }),
      h.p(null, informationalMessage)
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Search/index.js